export default function IconCollection({ name }) {
  switch (name) {
    case 'phone':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.9935 20.4631L20.6552 18.7967C21.1144 18.337 21.1144 17.5906 20.6552 17.1303L17.3317 14.6308C16.7695 14.2492 16.1291 14.171 15.67 14.6308L14.6527 15.651C13.6394 14.8948 12.5347 13.9869 11.5156 12.965C10.3634 11.8093 9.316 10.5239 8.4556 9.3682L9.43817 8.38215C9.89732 7.92242 9.81974 7.28031 9.43817 6.71578L6.94556 3.38303C6.56052 2.82429 5.74297 2.92272 5.28382 3.38303L3.62265 5.0494C2.70435 5.97002 2.99849 7.16682 3.62265 8.38215C3.62265 8.38215 5.68159 12.0606 8.82211 15.2098C11.7762 18.172 15.67 20.4631 15.67 20.4631C16.9803 20.9408 18.0758 21.3837 18.9935 20.4631Z"
            stroke="#008549"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'burgerMenu':
      return (
        <svg
          width="20"
          height="14"
          viewBox="0 0 20 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 0V1H0V0H20ZM0 7.5H20V6.5H0V7.5ZM20 14H0V13H20V14Z"
            fill="white"
          />
        </svg>
      );

    case 'search':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#fff"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 15.3L21.9 21.1L21.1 21.9L15.3 16C13.8225 17.2676 11.9465 17.9755 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C17.9755 11.9465 17.2676 13.8225 16 15.3ZM3 10C3 13.866 6.13401 17 10 17C11.8565 17 13.637 16.2625 14.9497 14.9497C16.2625 13.637 17 11.8565 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10Z"
            fill="white"
          />
        </svg>
      );

    case 'arrowLeft':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.0001 11.4999H5.5001L10.8001 6.0999L10.1001 5.3999L3.6001 11.9999L10.1001 18.5999L10.8001 17.8999L5.5001 12.4999H21.0001V11.4999Z"
            fill="#008549"
          />
        </svg>
      );

    case 'defaultLogo':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5293 24.2782V17.439H18.329V24.2903H16.5293V24.2782Z"
            fill="#008549"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.5757 18.943H21.9239V21.7336C21.9239 22.0114 21.9359 22.1926 21.9479 22.3134C21.9598 22.4221 22.0077 22.5188 22.0915 22.6034C22.1753 22.6879 22.3069 22.7242 22.4865 22.7242L23.5158 22.7L23.5996 24.1497C23.0011 24.2826 22.5343 24.355 22.2231 24.355C21.4092 24.355 20.8587 24.1738 20.5714 23.7993C20.2722 23.4369 20.1286 22.7604 20.1286 21.7698V15.5H21.9359V17.3846H23.5876V18.943H23.5757ZM13.9057 19.4428C13.59 19.4428 13.3229 19.3358 13.1165 19.122C12.9101 18.9082 12.8008 18.6469 12.8008 18.338C12.8008 18.0292 12.9101 17.7678 13.1043 17.554C13.3107 17.3402 13.5778 17.2452 13.8935 17.2452C14.2092 17.2452 14.4763 17.3521 14.6827 17.5659C14.8891 17.7797 14.9863 18.041 14.9863 18.3618C14.9863 18.6825 14.8891 18.932 14.6827 19.1458C14.4885 19.3358 14.2335 19.4428 13.9057 19.4428Z"
            fill="#008549"
          />
          <mask id="path-3-inside-1_1365_111223" fill="white">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M27.9004 2H11.9004V11.9L2 11.9V27.9H11.9004V38H27.9004V27.9H38V11.9L27.9004 11.9V2Z"
            />
          </mask>
          <path
            d="M11.9004 2V0H9.90039V2H11.9004ZM27.9004 2H29.9004V0H27.9004V2ZM11.9004 11.9V13.9H13.9004V11.9H11.9004ZM2 11.9L2 9.9H0V11.9H2ZM2 27.9H0V29.9H2V27.9ZM11.9004 27.9H13.9004V25.9H11.9004V27.9ZM11.9004 38H9.90039V40H11.9004V38ZM27.9004 38V40H29.9004V38H27.9004ZM27.9004 27.9V25.9H25.9004V27.9H27.9004ZM38 27.9V29.9H40V27.9H38ZM38 11.9H40V9.9H38V11.9ZM27.9004 11.9H25.9004V13.9H27.9004V11.9ZM11.9004 4H27.9004V0H11.9004V4ZM13.9004 11.9V2H9.90039V11.9H13.9004ZM2 13.9L11.9004 13.9V9.9L2 9.9L2 13.9ZM4 27.9V11.9H0V27.9H4ZM11.9004 25.9H2V29.9H11.9004V25.9ZM13.9004 38V27.9H9.90039V38H13.9004ZM27.9004 36H11.9004V40H27.9004V36ZM25.9004 27.9V38H29.9004V27.9H25.9004ZM38 25.9H27.9004V29.9H38V25.9ZM36 11.9V27.9H40V11.9H36ZM27.9004 13.9L38 13.9V9.9L27.9004 9.9V13.9ZM25.9004 2V11.9H29.9004V2H25.9004Z"
            fill="#008549"
            mask="url(#path-3-inside-1_1365_111223)"
          />
        </svg>
      );

    case 'modalCloseX':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.7001 12L19.4001 18.6L18.6001 19.4L12.0001 12.7L5.4001 19.4L4.6001 18.6L11.3001 12L4.6001 5.39998L5.4001 4.59998L12.0001 11.3L18.6001 4.59998L19.4001 5.39998L12.7001 12Z"
            fill="#fff"
          />
        </svg>
      );

    case 'healthCareLogo':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.4023 0.5H13.6016C13.6959 0.500003 13.7851 0.544533 13.8418 0.620117L15.6016 2.96582L16.001 3.49902L16.4014 2.96582L18.1611 0.620117C18.2178 0.544531 18.307 0.5 18.4014 0.5H21.6006C21.6949 0.5 21.7841 0.544529 21.8408 0.620117L23.6006 2.96582L24 3.49902L24.4004 2.96582L26.1602 0.620117C26.2169 0.544528 26.3061 0.5 26.4004 0.5H29.5996C29.632 0.500079 29.6644 0.505225 29.6953 0.515625C29.8522 0.569003 29.9361 0.739741 29.8828 0.896484L27.252 8.61426L27.084 9.10742L27.584 9.25488L33.0996 10.8896V25.3809C33.0998 26.9608 32.7963 28.5259 32.2061 29.9912C30.7053 33.2341 28.7364 35.3339 26.3262 36.373L26.3008 36.3848L20.1348 39.4688C20.0506 39.5107 19.9514 39.5106 19.8672 39.4688L13.709 36.3848C11.2406 35.0965 9.26685 32.9807 7.79883 29.999C7.20654 28.5314 6.9022 26.9636 6.90234 25.3809V10.8896L12.418 9.25488L12.917 9.10742L12.749 8.61426L10.1182 0.896484H10.1191C10.1085 0.865216 10.1026 0.832593 10.1025 0.799805C10.1026 0.654975 10.2053 0.533889 10.3418 0.505859L10.4023 0.5ZM11.0488 1.76074L13.3281 8.45898L13.4854 8.9209L13.9502 8.77539L19.9102 6.91309H19.9121C19.97 6.89476 20.032 6.89475 20.0898 6.91309H20.0918L26.0469 8.77539L26.5117 8.9209L26.6689 8.45996L28.9531 1.76074L29.1787 1.09961H26.5498L26.4004 1.2998L24.2539 4.16211L24.209 4.20703C24.0863 4.30771 23.9126 4.3049 23.7939 4.20898L23.7471 4.16211L21.6006 1.2998L21.4512 1.09961H18.5508L18.4014 1.2998L16.2549 4.16211L16.21 4.20703C16.0714 4.32077 15.8679 4.30228 15.752 4.16699L13.6016 1.2998L13.4512 1.09961H10.8232L11.0488 1.76074ZM32.5 11.4189L32.1484 11.3096L20.1504 7.56055L20.001 7.51367L19.8516 7.56055L7.85352 11.3096L7.50195 11.4189V25.3789C7.48648 29.8146 9.99499 33.8722 13.9688 35.8428V35.8438L19.7773 38.749L20.001 38.8604L20.2246 38.749L26.0322 35.8447L26.3086 35.707V35.7012C30.0004 33.7467 32.3599 29.9628 32.4932 25.793L32.5 25.3789V11.4189Z"
            fill="white"
            stroke="white"
          />
          <path
            d="M18.8027 21.0894V26.4331H18.1367V21.0894H18.8027Z"
            fill="white"
            stroke="white"
          />
          <path
            d="M22.1436 19.2939V21.0391H23.6738V21.4814H22.1328V24.5654C22.1328 24.8376 22.1444 25.0227 22.1572 25.1523L22.1904 25.3184C22.2361 25.4734 22.3205 25.6094 22.4326 25.7227C22.6506 25.9426 22.9391 25.9833 23.1533 25.9834L23.165 25.9824L23.6348 25.9717L23.6602 26.3994C23.3259 26.4623 23.0768 26.4931 22.9102 26.4932C22.1979 26.4932 21.896 26.3286 21.7773 26.1738L21.7715 26.167L21.7666 26.1602L21.7129 26.083C21.6591 25.9915 21.6044 25.8536 21.5605 25.6514C21.5028 25.3848 21.4707 25.037 21.4707 24.5996V19.2939H22.1436ZM15.1973 20.9102C15.3662 20.9102 15.4798 20.962 15.5684 21.0537C15.6589 21.1475 15.7089 21.2602 15.709 21.4434C15.709 21.6179 15.6633 21.7202 15.5723 21.8164C15.4936 21.8912 15.388 21.9443 15.209 21.9443C15.0401 21.9443 14.9264 21.8923 14.8379 21.8008C14.7357 21.6949 14.6856 21.5766 14.6855 21.4219C14.6855 21.2674 14.7356 21.145 14.833 21.0361C14.9117 20.9579 15.0184 20.9102 15.1973 20.9102Z"
            fill="white"
            stroke="white"
          />
        </svg>
      );

    case 'blueSearch':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 15.3L21.9 21.1L21.1 21.9L15.3 16C13.8225 17.2676 11.9465 17.9755 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C17.9755 11.9465 17.2676 13.8225 16 15.3ZM3 10C3 13.866 6.13401 17 10 17C11.8565 17 13.637 16.2625 14.9497 14.9497C16.2625 13.637 17 11.8565 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10Z"
            fill="#008549"
          />
        </svg>
      );

    case 'purpleArrowRight':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.9 5L13.2 5.7L18.5 11.1H3V12.1H18.5L13.2 17.5L13.9 18.2L20.5 11.6L13.9 5Z"
            fill="#9C0769"
          />
        </svg>
      );
    // case 'chevron-down':
    //   return (
    //     <svg
    //       width="24"
    //       height="24"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         d="M12 15.2L6.40002 9.60005L7.10002 8.80005L12 13.7L16.9 8.80005L17.6 9.60005L12 15.2Z"
    //         fill="white"
    //       />
    //     </svg>
    //   );
    case 'rightPointArrow':
      return (
        <svg
          width="36"
          height="37"
          viewBox="0 0 36 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.4012 26.8286L13.2012 25.7786L20.5512 18.4286L13.2012 11.0786L14.4012 10.0286L22.8012 18.4286L14.4012 26.8286Z"
            fill="#9C0769"
          />
        </svg>
      );

    case 'book':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.24523 4.38889C3.30051 3.88889 3.7244 3.5 4.23913 3.5H10.4853C10.7543 3.5 11.012 3.6084 11.2002 3.80071L12 4.61833L12.7998 3.80071C12.988 3.6084 13.2457 3.5 13.5147 3.5H19.7609C20.2756 3.5 20.6995 3.88889 20.7548 4.38889H21.5C22.0523 4.38889 22.5 4.8366 22.5 5.38889V19.5C22.5 20.0523 22.0523 20.5 21.5 20.5H2.5C1.94772 20.5 1.5 20.0523 1.5 19.5V5.38889C1.5 4.8366 1.94771 4.38889 2.5 4.38889H3.24523ZM3.23913 5.38889H2.5V19.5H11.2462L10.4853 18.7222H4.23913C3.68685 18.7222 3.23913 18.2745 3.23913 17.7222V5.38889ZM12.7538 19.5H21.5V5.38889H20.7609V17.7222C20.7609 18.2745 20.3132 18.7222 19.7609 18.7222H13.5147L12.7538 19.5ZM12.5 18.3294L12.7998 18.0229C12.988 17.8306 13.2457 17.7222 13.5147 17.7222H19.7609V4.5L13.5147 4.5L12.5 5.53723V18.3294ZM11.5 5.53723L10.4853 4.5L4.23913 4.5V17.7222H10.4853C10.7543 17.7222 11.012 17.8306 11.2002 18.0229L11.5 18.3294V5.53723Z"
            fill="#9C0769"
          />
        </svg>
      );
    case 'PurpleUser':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.0001 21.6666C23.682 21.6666 26.6667 18.6819 26.6667 15V9.99998C26.6667 6.31808 23.682 3.33331 20.0001 3.33331C16.3182 3.33331 13.3334 6.31808 13.3334 9.99998V15C13.3334 18.6819 16.3182 21.6666 20.0001 21.6666ZM15.0001 9.99998C15.0001 7.23856 17.2387 4.99998 20.0001 4.99998C22.7615 4.99998 25.0001 7.23856 25.0001 9.99998V15C25.0001 17.7614 22.7615 20 20.0001 20C17.2387 20 15.0001 17.7614 15.0001 15V9.99998ZM31.6667 36.6666H33.3334C33.3334 29.3028 27.3639 23.3333 20.0001 23.3333C12.6363 23.3333 6.66675 29.3028 6.66675 36.6666H8.33341C8.33341 30.2233 13.5568 25 20.0001 25C26.4434 25 31.6667 30.2233 31.6667 36.6666Z"
            fill="#9C0769"
          />
        </svg>
      );
    case 'star':
      return (
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 1.9856L9.49997 9.4856H1.59998L7.99997 14.1856L5.59998 21.7856L12 17.0856L18.4 21.7856L16 14.1856L22.4 9.4856H14.5L12 1.9856Z"
            fill="#A3ADB7"
          />
        </svg>
      );

    case 'share':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5 16C15.9721 15.3705 16.7131 15 17.5 15C18.8807 15 20 16.1193 20 17.5C20 18.8807 18.8807 20 17.5 20C16.1193 20 15 18.8807 15 17.5C14.9854 17.2949 15.0197 17.0893 15.1 16.9L7.5 13.5C6.85435 14.3608 5.73029 14.712 4.70943 14.3717C3.68858 14.0314 3 13.0761 3 12C3 10.9239 3.68858 9.96856 4.70943 9.62827C5.73029 9.28799 6.85435 9.63912 7.5 10.5L15.1 7.09998C15.0197 6.91071 14.9854 6.70508 15 6.49998C15 5.27384 15.8892 4.22867 17.0995 4.03226C18.3099 3.83586 19.484 4.5462 19.8717 5.70941C20.2594 6.87263 19.7464 8.14537 18.6603 8.71443C17.5742 9.28349 16.2357 8.98089 15.5 7.99998L7.9 11.4C7.98031 11.5893 8.01458 11.7949 8 12C8.01458 12.2051 7.98031 12.4107 7.9 12.6L15.5 16ZM19 6.49998C19 5.67156 18.3284 4.99998 17.5 4.99998C16.6716 4.99998 16 5.67156 16 6.49998C16 7.32841 16.6716 7.99998 17.5 7.99998C18.3284 7.99998 19 7.32841 19 6.49998ZM5.5 13.5C4.67157 13.5 4 12.8284 4 12C4 11.1716 4.67157 10.5 5.5 10.5C6.32843 10.5 7 11.1716 7 12C7 12.8284 6.32843 13.5 5.5 13.5ZM16 17.5C16 18.3284 16.6716 19 17.5 19C18.3284 19 19 18.3284 19 17.5C19 16.6716 18.3284 16 17.5 16C16.6716 16 16 16.6716 16 17.5Z"
            fill="#008549"
          />
        </svg>
      );

    case 'outlineHospital':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.5 5.5H30.5V6.5H29.5V14H37V15H36.5V33.5H38V34.5H2V33.5H3.5V15H3V14H10.5V6.5H9.5V5.5ZM11.5 6.5V33.5H15V26H14V25H26V26H25V33.5H28.5V6.5H11.5ZM29.5 33.5H35.5V15H29.5V18.5H34V19.5H29.5V24H34V25H29.5V29H34V30H29.5V33.5ZM24 33.5V26H16V33.5H24ZM10.5 33.5V30H6V29H10.5V25H6V24H10.5V19.5H6V18.5H10.5V15H4.5V33.5H10.5ZM18 10H22V13H25V17H22V20H18V17H15V13H18V10ZM19 11V14H16V16H19V19H21V16H24V14H21V11H19Z"
            fill="#008549"
          />
        </svg>
      );

    case 'outlineRedirect':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 4H13.5C13.2239 4 13 4.22386 13 4.5C13 4.77614 13.2239 5 13.5 5H18.1996L9.83073 13.3689C9.63547 13.5642 9.63547 13.8808 9.83073 14.076C10.026 14.2713 10.3426 14.2713 10.5378 14.076L19 5.61385V10.5C19 10.7761 19.2239 11 19.5 11C19.7761 11 20 10.7761 20 10.5V5C20 4.44772 19.5523 4 19 4ZM17.01 12.5C17.01 12.2239 17.2339 12 17.51 12C17.7784 12.0053 17.9947 12.2216 18 12.49V18C18 19.6569 16.6569 21 15 21H6C4.34315 21 3 19.6569 3 18V9C3 7.34315 4.34315 6 6 6H11C11.2739 6.00532 11.4947 6.22609 11.5 6.5C11.5 6.77614 11.2761 7 11 7H6C4.89543 7 4 7.89543 4 9V18C4 19.1046 4.89543 20 6 20H15.01C16.1146 20 17.01 19.1046 17.01 18V12.5Z"
            fill="#008549"
          />
        </svg>
      );

    case 'userGreen':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.9993 21.6667C23.6812 21.6667 26.666 18.6819 26.666 15V10C26.666 6.31814 23.6812 3.33337 19.9993 3.33337C16.3175 3.33337 13.3327 6.31814 13.3327 10V15C13.3327 18.6819 16.3175 21.6667 19.9993 21.6667ZM14.9993 10C14.9993 7.23862 17.2379 5.00004 19.9993 5.00004C22.7608 5.00004 24.9993 7.23862 24.9993 10V15C24.9993 17.7615 22.7608 20 19.9993 20C17.2379 20 14.9993 17.7615 14.9993 15V10ZM31.666 36.6667H33.3327C33.3327 29.3029 27.3631 23.3334 19.9993 23.3334C12.6356 23.3334 6.66602 29.3029 6.66602 36.6667H8.33268C8.33268 30.2234 13.556 25 19.9993 25C26.4427 25 31.666 30.2234 31.666 36.6667Z"
            fill="#008549"
          />
        </svg>
      );

    case 'purpleDoc':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.834 3.33325H24.5007L31.6673 10.4999V34.1666C31.6673 35.5473 30.548 36.6666 29.1673 36.6666H10.834C9.45327 36.6666 8.33398 35.5473 8.33398 34.1666V5.83325C8.33398 4.45254 9.45327 3.33325 10.834 3.33325ZM28.834 9.99992L25.0007 6.16659V9.16659C25.0007 9.62682 25.3737 9.99992 25.834 9.99992H28.834ZM29.1673 34.9999H10.834C10.3737 34.9999 10.0007 34.6268 10.0007 34.1666V5.83325C10.0007 5.37301 10.3737 4.99992 10.834 4.99992H23.334V9.16659C23.334 10.5473 24.4533 11.6666 25.834 11.6666H30.0007V34.1666C30.0007 34.6268 29.6276 34.9999 29.1673 34.9999ZM26.6673 14.9999H13.334V16.6666H26.6673V14.9999ZM13.334 18.3333H26.6673V19.9999H13.334V18.3333ZM20.0007 21.6666H13.334V23.3333H20.0007V21.6666Z"
            fill="#9C0769"
          />
        </svg>
      );

    case 'purplePDF':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.5 3.33337H10.8333C9.45262 3.33337 8.33333 4.45266 8.33333 5.83337L8.33333 26.6667H10V5.83337C10 5.37314 10.3731 5.00004 10.8333 5.00004H23.3333V9.16671C23.3333 10.5474 24.4526 11.6667 25.8333 11.6667H30V34.1667C30 34.6269 29.6269 35 29.1667 35L26.6667 35V36.6667H29.1667C30.5474 36.6667 31.6667 35.5474 31.6667 34.1667V10.5L24.5 3.33337ZM25 6.16663L28.8333 9.99996H25.8333C25.3731 9.99996 25 9.62686 25 9.16663V6.16663ZM8.26195 34.2402H6.80059V36.6667H5V28.3334H8.26195C10.367 28.3334 11.4195 29.2974 11.4195 31.2255C11.4195 32.1978 11.1499 32.9453 10.6105 33.4682C10.0799 33.9829 9.29707 34.2402 8.26195 34.2402ZM6.80059 32.7942H8.2489C9.14485 32.7942 9.59282 32.2713 9.59282 31.2255C9.59282 30.7108 9.48409 30.3432 9.26663 30.1226C9.04916 29.8938 8.70992 29.7794 8.2489 29.7794H6.80059V32.7942ZM15.6714 36.6667H12.6834V28.3334H15.6714C16.4368 28.3334 17.0675 28.411 17.5633 28.5662C18.0591 28.7133 18.4418 28.9625 18.7115 29.3138C18.9898 29.6569 19.1812 30.0654 19.2856 30.5393C19.39 31.0049 19.4422 31.6136 19.4422 32.3652C19.4422 33.1169 19.3943 33.7419 19.2986 34.2402C19.203 34.7304 19.0203 35.1716 18.7506 35.5638C18.4897 35.9478 18.1069 36.2296 17.6024 36.4094C17.0979 36.5809 16.4542 36.6667 15.6714 36.6667ZM17.5633 33.3579C17.5807 33.0964 17.5894 32.737 17.5894 32.2794C17.5894 31.8138 17.572 31.442 17.5372 31.1643C17.5024 30.8865 17.4198 30.6332 17.2893 30.4044C17.1588 30.1757 16.9631 30.0205 16.7021 29.9388C16.4499 29.8489 16.1063 29.804 15.6714 29.804H14.484V35.1961H15.6714C16.3237 35.1961 16.7978 35.0409 17.0936 34.7304C17.3458 34.4772 17.5024 34.0196 17.5633 33.3579ZM21.0039 28.3334V36.6667H22.8045V33.7255H25.9621V32.2549H22.8045V29.804H26.6667V28.3334H21.0039Z"
            fill="#9C0769"
          />
        </svg>
      );

    case 'plusTopLeft':
      return (
        <svg
          width="123"
          height="123"
          viewBox="0 0 123 123"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.4">
            <mask id="path-1-inside-1_224_2154" fill="white">
              <path d="M85.7959 36.5898H116.853V85.79H85.7959V116.849H36.5957V85.79H6.15234V36.5898H36.5957V6.14844H85.7959V36.5898Z" />
            </mask>
            <path
              d="M85.7959 36.5898H81.7959V40.5898H85.7959V36.5898ZM116.853 36.5898H120.853V32.5898H116.853V36.5898ZM116.853 85.79V89.79H120.853V85.79H116.853ZM85.7959 85.79V81.79H81.7959V85.79H85.7959ZM85.7959 116.849V120.849H89.7959V116.849H85.7959ZM36.5957 116.849H32.5957V120.849H36.5957V116.849ZM36.5957 85.79H40.5957V81.79H36.5957V85.79ZM6.15234 85.79H2.15234V89.79H6.15234V85.79ZM6.15234 36.5898V32.5898H2.15234V36.5898H6.15234ZM36.5957 36.5898V40.5898H40.5957V36.5898H36.5957ZM36.5957 6.14844V2.14844H32.5957V6.14844H36.5957ZM85.7959 6.14844H89.7959V2.14844H85.7959V6.14844ZM85.7959 36.5898V40.5898H116.853V36.5898V32.5898H85.7959V36.5898ZM116.853 36.5898H112.853V85.79H116.853H120.853V36.5898H116.853ZM116.853 85.79V81.79H85.7959V85.79V89.79H116.853V85.79ZM85.7959 85.79H81.7959V116.849H85.7959H89.7959V85.79H85.7959ZM85.7959 116.849V112.849H36.5957V116.849V120.849H85.7959V116.849ZM36.5957 116.849H40.5957V85.79H36.5957H32.5957V116.849H36.5957ZM36.5957 85.79V81.79H6.15234V85.79V89.79H36.5957V85.79ZM6.15234 85.79H10.1523V36.5898H6.15234H2.15234V85.79H6.15234ZM6.15234 36.5898V40.5898H36.5957V36.5898V32.5898H6.15234V36.5898ZM36.5957 36.5898H40.5957V6.14844H36.5957H32.5957V36.5898H36.5957ZM36.5957 6.14844V10.1484H85.7959V6.14844V2.14844H36.5957V6.14844ZM85.7959 6.14844H81.7959V36.5898H85.7959H89.7959V6.14844H85.7959Z"
              fill="white"
              mask="url(#path-1-inside-1_224_2154)"
            />
          </g>
        </svg>
      );

    // case 'plusBottomLeft':
    //   return (
    //     <svg
    //       width="176"
    //       height="180"
    //       viewBox="0 0 176 180"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <mask id="path-1-inside-1_19360_25517" fill="white">
    //         <path
    //           fillRule="evenodd"
    //           clipRule="evenodd"
    //           d="M120.359 0.849854H33.5595V54.5574L-20.1499 54.5574L-20.1499 141.357H33.5595V196.15H120.359V141.357H175.15V54.5574L120.359 54.5574V0.849854Z"
    //         />
    //       </mask>
    //       <path
    //         d="M33.5595 0.849854V-3.15015H29.5595V0.849854H33.5595ZM120.359 0.849854H124.359V-3.15015H120.359V0.849854ZM33.5595 54.5574V58.5574H37.5595V54.5574H33.5595ZM-20.1499 54.5574L-20.1499 50.5574H-24.1499L-24.1499 54.5574H-20.1499ZM-20.1499 141.357H-24.1499V145.357H-20.1499V141.357ZM33.5595 141.357H37.5595V137.357H33.5595V141.357ZM33.5595 196.15H29.5595V200.15H33.5595V196.15ZM120.359 196.15V200.15H124.359V196.15H120.359ZM120.359 141.357V137.357H116.359V141.357H120.359ZM175.15 141.357V145.357H179.15V141.357H175.15ZM175.15 54.5574H179.15V50.5574H175.15V54.5574ZM120.359 54.5574H116.359V58.5574H120.359V54.5574ZM33.5595 4.84985H120.359V-3.15015H33.5595V4.84985ZM37.5595 54.5574V0.849854H29.5595V54.5574H37.5595ZM-20.1499 58.5574L33.5595 58.5574V50.5574L-20.1499 50.5574L-20.1499 58.5574ZM-16.1499 141.357L-16.1499 54.5574H-24.1499L-24.1499 141.357H-16.1499ZM33.5595 137.357H-20.1499V145.357H33.5595V137.357ZM37.5595 196.15V141.357H29.5595V196.15H37.5595ZM120.359 192.15H33.5595V200.15H120.359V192.15ZM116.359 141.357V196.15H124.359V141.357H116.359ZM175.15 137.357H120.359V145.357H175.15V137.357ZM171.15 54.5574V141.357H179.15V54.5574H171.15ZM120.359 58.5574L175.15 58.5574V50.5574L120.359 50.5574V58.5574ZM116.359 0.849854V54.5574H124.359V0.849854H116.359Z"
    //         fill="white"
    //         mask="url(#path-1-inside-1_19360_25517)"
    //       />
    //     </svg>
    //   );

    // case 'plusTopRight':
    //   return (
    //     <svg
    //       width="259"
    //       height="257"
    //       viewBox="0 0 259 257"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <mask id="path-1-inside-1_19360_25506" fill="white">
    //         <path
    //           fillRule="evenodd"
    //           clipRule="evenodd"
    //           d="M213.441 -33.7H91.0407V42.0349L15.3003 42.0349L15.3003 164.435H91.0407V241.7H213.441V164.435H290.7V42.0349L213.441 42.0349V-33.7Z"
    //         />
    //       </mask>
    //       <path
    //         d="M91.0407 -33.7V-37.7H87.0407V-33.7H91.0407ZM213.441 -33.7H217.441V-37.7H213.441V-33.7ZM91.0407 42.0349V46.0349H95.0407V42.0349H91.0407ZM15.3003 42.0349L15.3003 38.0349H11.3003L11.3003 42.0349H15.3003ZM15.3003 164.435H11.3003V168.435H15.3003V164.435ZM91.0407 164.435H95.0407V160.435H91.0407V164.435ZM91.0407 241.7H87.0407V245.7H91.0407V241.7ZM213.441 241.7V245.7H217.441V241.7H213.441ZM213.441 164.435V160.435H209.441V164.435H213.441ZM290.7 164.435V168.435H294.7V164.435H290.7ZM290.7 42.0349H294.7V38.0349H290.7V42.0349ZM213.441 42.0349H209.441V46.0349H213.441V42.0349ZM91.0407 -29.7H213.441V-37.7H91.0407V-29.7ZM95.0407 42.0349V-33.7H87.0407V42.0349H95.0407ZM15.3003 46.0349L91.0407 46.0349V38.0349L15.3003 38.0349L15.3003 46.0349ZM19.3003 164.435L19.3003 42.0349H11.3003L11.3003 164.435H19.3003ZM91.0407 160.435H15.3003V168.435H91.0407V160.435ZM95.0407 241.7V164.435H87.0407V241.7H95.0407ZM213.441 237.7H91.0407V245.7H213.441V237.7ZM209.441 164.435V241.7H217.441V164.435H209.441ZM290.7 160.435H213.441V168.435H290.7V160.435ZM286.7 42.0349V164.435H294.7V42.0349H286.7ZM213.441 46.0349L290.7 46.0349V38.0349L213.441 38.0349V46.0349ZM209.441 -33.7V42.0349H217.441V-33.7H209.441Z"
    //         fill="white"
    //         mask="url(#path-1-inside-1_19360_25506)"
    //       />
    //     </svg>
    //   );

    // case 'plusBottomRight':
    //   return (
    //     <svg
    //       width="123"
    //       height="123"
    //       viewBox="0 0 123 123"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <g opacity="0.4">
    //         <mask id="path-1-inside-1_224_2154" fill="white">
    //           <path d="M85.7959 36.5898H116.853V85.79H85.7959V116.849H36.5957V85.79H6.15234V36.5898H36.5957V6.14844H85.7959V36.5898Z" />
    //         </mask>
    //         <path
    //           d="M85.7959 36.5898H81.7959V40.5898H85.7959V36.5898ZM116.853 36.5898H120.853V32.5898H116.853V36.5898ZM116.853 85.79V89.79H120.853V85.79H116.853ZM85.7959 85.79V81.79H81.7959V85.79H85.7959ZM85.7959 116.849V120.849H89.7959V116.849H85.7959ZM36.5957 116.849H32.5957V120.849H36.5957V116.849ZM36.5957 85.79H40.5957V81.79H36.5957V85.79ZM6.15234 85.79H2.15234V89.79H6.15234V85.79ZM6.15234 36.5898V32.5898H2.15234V36.5898H6.15234ZM36.5957 36.5898V40.5898H40.5957V36.5898H36.5957ZM36.5957 6.14844V2.14844H32.5957V6.14844H36.5957ZM85.7959 6.14844H89.7959V2.14844H85.7959V6.14844ZM85.7959 36.5898V40.5898H116.853V36.5898V32.5898H85.7959V36.5898ZM116.853 36.5898H112.853V85.79H116.853H120.853V36.5898H116.853ZM116.853 85.79V81.79H85.7959V85.79V89.79H116.853V85.79ZM85.7959 85.79H81.7959V116.849H85.7959H89.7959V85.79H85.7959ZM85.7959 116.849V112.849H36.5957V116.849V120.849H85.7959V116.849ZM36.5957 116.849H40.5957V85.79H36.5957H32.5957V116.849H36.5957ZM36.5957 85.79V81.79H6.15234V85.79V89.79H36.5957V85.79ZM6.15234 85.79H10.1523V36.5898H6.15234H2.15234V85.79H6.15234ZM6.15234 36.5898V40.5898H36.5957V36.5898V32.5898H6.15234V36.5898ZM36.5957 36.5898H40.5957V6.14844H36.5957H32.5957V36.5898H36.5957ZM36.5957 6.14844V10.1484H85.7959V6.14844V2.14844H36.5957V6.14844ZM85.7959 6.14844H81.7959V36.5898H85.7959H89.7959V6.14844H85.7959Z"
    //           fill="white"
    //           mask="url(#path-1-inside-1_224_2154)"
    //         />
    //       </g>
    //     </svg>
    //   );

    // case 'plusTopRightSmall':
    //   return (
    //     <svg
    //       width="76"
    //       height="76"
    //       viewBox="0 0 76 76"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <g opacity="0.4">
    //         <mask id="path-1-inside-1_19360_25499" fill="white">
    //           <path
    //             fillRule="evenodd"
    //             clipRule="evenodd"
    //             d="M53.0101 3.79993H22.6101V22.6098L3.80029 22.6098V53.0098H22.6101V72.1999H53.0101V53.0098H72.2003V22.6098L53.0101 22.6098V3.79993Z"
    //           />
    //         </mask>
    //         <path
    //           d="M22.6101 3.79993V-0.200073H18.6101V3.79993H22.6101ZM53.0101 3.79993H57.0101V-0.200073H53.0101V3.79993ZM22.6101 22.6098V26.6098H26.6101V22.6098H22.6101ZM3.80029 22.6098L3.80029 18.6098H-0.199707V22.6098H3.80029ZM3.80029 53.0098H-0.199707V57.0098H3.80029V53.0098ZM22.6101 53.0098H26.6101V49.0098H22.6101V53.0098ZM22.6101 72.1999H18.6101V76.1999H22.6101V72.1999ZM53.0101 72.1999V76.1999H57.0101V72.1999H53.0101ZM53.0101 53.0098V49.0098H49.0101V53.0098H53.0101ZM72.2003 53.0098V57.0098H76.2003V53.0098H72.2003ZM72.2003 22.6098H76.2003V18.6098H72.2003V22.6098ZM53.0101 22.6098H49.0101V26.6098H53.0101V22.6098ZM22.6101 7.79993H53.0101V-0.200073H22.6101V7.79993ZM26.6101 22.6098V3.79993H18.6101V22.6098H26.6101ZM3.80029 26.6098L22.6101 26.6098V18.6098L3.80029 18.6098L3.80029 26.6098ZM7.80029 53.0098V22.6098H-0.199707V53.0098H7.80029ZM22.6101 49.0098H3.80029V57.0098H22.6101V49.0098ZM26.6101 72.1999V53.0098H18.6101V72.1999H26.6101ZM53.0101 68.1999H22.6101V76.1999H53.0101V68.1999ZM49.0101 53.0098V72.1999H57.0101V53.0098H49.0101ZM72.2003 49.0098H53.0101V57.0098H72.2003V49.0098ZM68.2003 22.6098V53.0098H76.2003V22.6098H68.2003ZM53.0101 26.6098L72.2003 26.6098V18.6098L53.0101 18.6098V26.6098ZM49.0101 3.79993V22.6098H57.0101V3.79993H49.0101Z"
    //           fill="white"
    //           mask="url(#path-1-inside-1_19360_25499)"
    //         />
    //       </g>
    //     </svg>
    //   );

    case 'user':
      return (
        <>
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
              stroke="black"
              strokeWidth="null"
            ></path>
            <path
              d="M20 21V20.1429C20 19.0805 20 18.5493 19.8997 18.1099C19.5578 16.6119 18.3881 15.4422 16.8901 15.1003C16.4507 15 15.9195 15 14.8571 15H10C8.13623 15 7.20435 15 6.46927 15.3045C5.48915 15.7105 4.71046 16.4892 4.30448 17.4693C4 18.2044 4 19.1362 4 21"
              stroke="black"
              strokeWidth="null"
              strokeLinecap="round"
            ></path>
          </svg>
        </>
      );

    case 'tealDropDown':
      return (
        <svg
          width="8"
          height="6"
          viewBox="0 0 8 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.99994 5.13334L0.266602 1.4L0.733268 0.866669L3.99994 4.13334L7.2666 0.866669L7.73327 1.4L3.99994 5.13334Z"
            fill="#008549"
          />
        </svg>
      );

    // case 'tealDropDownCheckbox':
    //   return (
    //     <svg
    //       width="24"
    //       height="24"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         d="M12 15.2L6.40002 9.60005L7.10002 8.80005L12 13.7L16.9 8.80005L17.6 9.60005L12 15.2Z"
    //         fill="#008549"
    //       />
    //     </svg>
    //   );

    // case 'purpleDropDown':
    //   return (
    //     <svg
    //       width="24"
    //       height="24"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         d="M12.0004 15.2L6.40039 9.6L7.10039 8.8L12.0004 13.7L16.9004 8.8L17.6004 9.6L12.0004 15.2Z"
    //         fill="#9C0769"
    //       />
    //     </svg>
    //   );
    case 'location-hollow':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.31007 11.65L12.0001 22L17.6901 11.63C18.221 10.6722 18.4997 9.59515 18.5001 8.50002C18.4968 5.78348 16.8046 3.35546 14.2571 2.41219C11.7096 1.46892 8.84413 2.20937 7.07252 4.26874C5.30091 6.32811 4.99682 9.272 6.31007 11.65ZM7.25891 5.70964C8.24763 4.03025 10.0512 2.99947 12.0001 3.00002C13.9568 2.99193 15.7704 4.02401 16.7629 5.71035C17.7553 7.39669 17.7771 9.48333 16.8201 11.19L12.0001 20L7.19007 11.17C6.244 9.46624 6.27019 7.38902 7.25891 5.70964Z"
            fill="#5C6F82"
          />
        </svg>
      );

    case 'whatsapp':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"
            fill="currentColor"
          />
        </svg>
      );

    case 'facebook':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
            fill="currentColor"
          />
        </svg>
      );

    case 'twitter':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"
            fill="currentColor"
          />
        </svg>
      );

    case 'linkedin':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
            fill="currentColor"
          />
        </svg>
      );

    case 'telegram':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"
            fill="currentColor"
          />
        </svg>
      );

    case 'email':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
            fill="currentColor"
          />
        </svg>
      );

    case 'check':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
            fill="currentColor"
          />
        </svg>
      );

    case 'copy':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
            fill="currentColor"
          />
        </svg>
      );


    case 'plusIcon':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 12.5H12.5V20H11.5V12.5H4V11.5H11.5V4H12.5V11.5H20V12.5Z"
            fill="#008549"
          />
        </svg>
      );

    case 'minusIcon':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M20 12.5H4V11.5H20V12.5Z" fill="#008549" />
        </svg>
      );

    case 'download':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-download-icon lucide-download"><path d="M12 15V3"/><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m7 10 5 5 5-5"/></svg>
      );
    case 'arrowDown':
      return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-down-icon lucide-arrow-down"><path d="M12 5v14"/><path d="m19 12-7 7-7-7"/></svg>      );

    case 'arrowUp':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-up-icon lucide-arrow-up"><path d="m5 12 7-7 7 7"/><path d="M12 19V5"/></svg>
      )
    case 'calloutInfoTitle':
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
          <circle cx="12" cy="7.5" r="1" fill="currentColor" />
          <path d="M12 10.5V16.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      );
    case 'calloutSuccessTitle':
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
          <path
            d="M8 12.5l2.5 2.5L16 9.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'calloutWarningTitle':
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
          <path
            d="M12 7.5V13"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <circle cx="12" cy="16.5" r="1.1" fill="currentColor" />
        </svg>
      );
    case 'calloutErrorTitle':
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
          <path
            d="M9.2 9.2l5.6 5.6M14.8 9.2l-5.6 5.6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'calloutApprofondimentoTitle':
      return (
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          shapeRendering="geometricPrecision"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="11" cy="11" r="6.5" stroke="currentColor" strokeWidth="1.75" />
          <path
            d="M16 16l4 4"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11 8.5v5M8.5 11h5"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'calloutActionPlus':
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
          <path d="M12 7v10M7 12h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
    case 'calloutActionMinus':
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
          <path d="M7 12h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
    case 'calloutActionDownload':
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 4v10m0 0l-4-4m4 4l4-4M5 18h14"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    default:
      return <></>;
  }
}
